/**
 * Valeur numérique souvent reçue en string : > 1 → « sujets », sinon → « sujet ».
 * Si non numérique, « sujets » par défaut (aligné fiche intervention épaysage UI).
 */
export function formatValueWithSujetLabel(
  raw: string | number | null | undefined
): string {
  const trimmed = raw == null ? '' : String(raw).trim();
  if (trimmed === '') return '';
  const n = Number.parseFloat(trimmed.replace(',', '.'));
  if (Number.isNaN(n)) {
    return `${trimmed} sujets`;
  }
  const mot = n > 1 ? 'sujets' : 'sujet';
  return `${trimmed} ${mot}`;
}
